var exports = {
  "tB": "ApplicationDetail.module__page___RGVJb2",
  "Vr": "ApplicationDetail.module__pageHeader___RGVJb2",
  "d1": "ApplicationDetail.module__heroCard___RGVJb2",
  "CI": "ApplicationDetail.module__heroTop___RGVJb2",
  "ZY": "ApplicationDetail.module__heroTitle___RGVJb2",
  "Uz": "ApplicationDetail.module__metaInput___RGVJb2",
  "Io": "ApplicationDetail.module__pill___RGVJb2",
  "RD": "ApplicationDetail.module__intentLabel___RGVJb2",
  "WA": "ApplicationDetail.module__detailGrid___RGVJb2",
  "fP": "ApplicationDetail.module__columnStack___RGVJb2",
  "E7": "ApplicationDetail.module__sectionSpacer___RGVJb2",
  "Nr": "ApplicationDetail.module__card___RGVJb2",
  "Wg": "ApplicationDetail.module__cardDanger___RGVJb2",
  "MY": "ApplicationDetail.module__cardHeader___RGVJb2",
  "JJ": "ApplicationDetail.module__cardTitle___RGVJb2",
  "Dc": "ApplicationDetail.module__cardSubtitle___RGVJb2",
  "eB": "ApplicationDetail.module__cardActions___RGVJb2",
  "zI": "ApplicationDetail.module__cardBody___RGVJb2",
  "tx": "ApplicationDetail.module__secretRow___RGVJb2",
  "cD": "ApplicationDetail.module__secretActions___RGVJb2",
  "PZ": "ApplicationDetail.module__fieldStack___RGVJb2",
  "Bq": "ApplicationDetail.module__toggleDescription___RGVJb2",
  "rP": "ApplicationDetail.module__redirectList___RGVJb2",
  "bs": "ApplicationDetail.module__redirectRow___RGVJb2",
  "C2": "ApplicationDetail.module__redirectActions___RGVJb2",
  "py": "ApplicationDetail.module__redirectRemoveButton___RGVJb2",
  "t_": "ApplicationDetail.module__createRedirectButton___RGVJb2",
  "PM": "ApplicationDetail.module__scopeGrid___RGVJb2",
  "bk": "ApplicationDetail.module__fieldLabel___RGVJb2",
  "Jb": "ApplicationDetail.module__scopeList___RGVJb2",
  "LR": "ApplicationDetail.module__botPermissionList___RGVJb2",
  "_": "ApplicationDetail.module__scopeItem___RGVJb2",
  "wS": "ApplicationDetail.module__scopeCheckbox___RGVJb2",
  "$o": "ApplicationDetail.module__scopeLabel___RGVJb2",
  "Ud": "ApplicationDetail.module__avatarRow___RGVJb2",
  "_Q": "ApplicationDetail.module__avatarPreview___RGVJb2",
  "rZ": "ApplicationDetail.module__avatarPlaceholder___RGVJb2",
  "Jm": "ApplicationDetail.module__tagRow___RGVJb2",
  "vb": "ApplicationDetail.module__discriminatorInput___RGVJb2",
  "jY": "ApplicationDetail.module__validationBox___RGVJb2",
  "JE": "ApplicationDetail.module__bannerRow___RGVJb2",
  "HF": "ApplicationDetail.module__builderResult___RGVJb2",
  "Ml": "ApplicationDetail.module__loadingState___RGVJb2",
  "cy": "ApplicationDetail.module__helperText___RGVJb2",
  "RJ": "ApplicationDetail.module__dangerContent___RGVJb2",
  "n7": "ApplicationDetail.module__dangerActions___RGVJb2",
  "z3": "ApplicationDetail.module__error___RGVJb2",
  "sM": "ApplicationDetail.module__srOnly___RGVJb2",
  "Mb": "ApplicationDetail.module__localizedBio___RGVJb2",
  "gj": "ApplicationDetail.module__localizedBioRemove___RGVJb2" + " " + "ApplicationDetail.module__redirectRemoveButton___RGVJb2",
};

module.exports = exports;
